/* eslint-disable max-len */
import { AllieIconProps } from '../../../components';

export const BellIcon: React.FC<AllieIconProps> = () => (
  <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.1219 20.4375C12.9571 20.7216 12.7205 20.9575 12.4358 21.1214C12.1512 21.2854 11.8285 21.3717 11.5 21.3717C11.1715 21.3717 10.8488 21.2854 10.5642 21.1214C10.2795 20.9575 10.0429 20.7216 9.87813 20.4375M17.125 8.25C17.125 6.75816 16.5324 5.32742 15.4775 4.27252C14.4226 3.21763 12.9918 2.625 11.5 2.625C10.0082 2.625 8.57742 3.21763 7.52252 4.27252C6.46763 5.32742 5.875 6.75816 5.875 8.25C5.875 14.8125 3.0625 16.6875 3.0625 16.6875H19.9375C19.9375 16.6875 17.125 14.8125 17.125 8.25Z"
      stroke="white"
      strokeWidth="1.875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
